<template>
    <div class="icon-container">
        <i class="iconfont" :class="getIcon"></i>
    </div>
</template>

<script>

export default {
    props: {
        type: {
            type: String,
            default: 'home'
        }
    },
    computed: {
        getIcon() {
            return 'icon-' + this.type
        }
    }
}
</script>

<style lang="less" scoped>
@import url('//at.alicdn.com/t/c/font_4643123_19ec05ux832.css');



/* @import url('//at.alicdn.com/t/c/font_4643123_xna9a61lfv.css'); */
</style>